import {
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  Text
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useMutateVisit } from '../../hooks/visits'
import { useFormik } from 'formik'
import SimpleInput from '../../components/Shared/inputs/SimpleInput'
import { isStrictClientAreaSelectionEnabled } from '../../components/Shared/const'

const validationSchema = Yup.object().shape({
  area: Yup.string().required('Ingrese un área')
})

const getMantenedorAreaOptions = (visit) => {
  const locations = visit?.client?.locations || []

  return locations
    .filter((location) => location?.name)
    .map((location) => location.name)
}

export default function VisitEdit({ visit }) {
  const { user } = useSelector((state) => state.auth)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { mutateAsync: mutateVisit, isLoading: updateVisitIsLoading } =
    useMutateVisit('UPDATE')

  const strictAreaSelection = isStrictClientAreaSelectionEnabled()
  const areaOptions = getMantenedorAreaOptions(visit)
  const hasConfiguredAreas = areaOptions.length > 0

  const formik = useFormik({
    validationSchema,
    enableReinitialize: true,
    initialValues: {
      area: visit.visit.area || '',
      created_by: user.id
    },
    onSubmit: async (values) => {
      await mutateVisit({ ...values, id: visit.visit.id })
      onClose()
    }
  })

  return (
    <>
      <Button variant="outline" colorScheme="teal" onClick={onOpen}>
        Editar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Editar visita</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            {strictAreaSelection ? (
              hasConfiguredAreas ? (
                <FormControl
                  id="area"
                  isInvalid={formik.touched.area && Boolean(formik.errors.area)}
                >
                  <FormLabel>Área del cliente</FormLabel>
                  <Select
                    placeholder="Seleccione"
                    name="area"
                    value={formik.values.area}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {areaOptions.map((areaName) => (
                      <option key={areaName} value={areaName}>
                        {areaName}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage>
                    {formik.touched.area && formik.errors.area}
                  </FormErrorMessage>
                </FormControl>
              ) : (
                <Text color="orange.600" fontSize="sm">
                  Este cliente no tiene áreas configuradas. Configure las áreas a
                  tratar en el mantenedor de clientes antes de editar la visita.
                </Text>
              )
            ) : (
              <SimpleInput
                label="Área del cliente"
                name="area"
                placeholder="Ingrese el área manualmente"
                value={formik.values.area}
                errors={formik.touched.area && Boolean(formik.errors.area)}
                errorMsg={formik.touched.area && formik.errors.area}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            )}
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose}>Cancelar</Button>
            <Button
              colorScheme="teal"
              ml={3}
              isLoading={updateVisitIsLoading}
              onClick={formik.handleSubmit}
              isDisabled={
                strictAreaSelection &&
                (!hasConfiguredAreas || !formik.values.area)
              }
            >
              Guardar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
